import type { ComponentNameAndModule } from '@sitecore-jss/sitecore-jss-angular';

const loadChildren = () =>
  import('./core-search.lazy.module').then((module) => module.SearchLazyModule);

const defineImport = (path: string) => ({
  path,
  loadChildren,
});

export const searchLazyImports: ComponentNameAndModule[] = [
  defineImport('SearchResults'),
];
